import { _ as cr } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.is-array-7a29277f.js";
import "./es.array.concat-d1c9b847.js";
import "./es.function.name-b230e7d4.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.parse-float-020a2ae0.js";
import "./es.string.replace-f4cc3aea.js";
import { c as H } from "./index-8b07dec9.js";
import { useRef as nr, useState as or, useEffect as ur } from "react";
import O, { css as z } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as yr } from "./getMetrics-953aa4f8.js";
import "./carousel.js";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./index-5d0f31c6.js";
import { jsx as G } from "react/jsx-runtime";
import "./es.string.trim-6e13db75.js";
import { InputState as ar } from "./helperText.js";
import "./label.js";
import "./es.array.from-fe752fa6.js";
import { T as ir } from "./index-f5b44da3.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./es.array.join-c1bca812.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./aspectRatio.js";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./string-trim-14e37ad3.js";
import "./function-apply-4756dee6.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./array-method-is-strict-e5a3c878.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./combineRefs-c9ad2c39.js";
import "./useMediaQuery.js";
import "./isApiSupported-66660265.js";
import "./isClient-2f5bedbd.js";
import "./iconButton.js";
import "./button.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./useIsMounted.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./aria.js";
import "./popupTip-06ee114c.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useWindowSize.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./tooltip.js";
import "./uniqueId.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./es.string.search-d27ec57a.js";
import "./es.function.bind-b4bdcd4b.js";
import "@ucl/ucl-translation";
import "./image.js";
import "./mediaDisclosureButton.js";
import "./index-f2264f1e.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./badge.js";
import "./es.string.small-23219181.js";
import "./string-html-forced-a746405b.js";
import "./species-constructor-00346775.js";
var tr = function(r) {
  var c = r.value, o = r.groupSeparator, m = o === void 0 ? "," : o, g = r.decimalSeparator, t = g === void 0 ? "." : g, d = r.allowDecimals, D = d === void 0 ? !0 : d, y = r.decimalsLimit, S = y === void 0 ? 2 : y, p = r.allowNegativeValue, R = p === void 0 ? !0 : p;
  if (c === "-")
    return c;
  var B = /((^|\D)-\d)|(-)/, h = B.test(c), P = mr(c, m), b = dr(P, [m, t]), s = b, f = h && R ? "-" : "";
  if (t && s.includes(t)) {
    var N = b.split(t), L = N[0], v = N[1], K = S && v ? v.slice(0, S) : v, A = D ? "" + t + K : "";
    return "" + f + L + A;
  }
  return "" + f + s;
}, lr = function(r, c) {
  var o;
  return ((o = c.split(r)[1]) == null ? void 0 : o.length) || 0;
}, U = function(r) {
  return r.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}, mr = function(r, c) {
  c === void 0 && (c = ",");
  var o = new RegExp(U(c), "g");
  return r.replace(o, "");
}, dr = function(r, c) {
  var o = U(c.join("")), m = new RegExp("[^\\d" + o + "]", "gi");
  return r.replace(m, "");
}, pr = [{
  currency: "Albania Lek",
  currencyCode: "ALL",
  currencySymbol: "&#76;&#101;&#107;"
}, {
  currency: "Afghanistan Afghani",
  currencyCode: "AFN",
  currencySymbol: "&#1547;"
}, {
  currency: "Argentina Peso",
  currencyCode: "ARS",
  currencySymbol: "&#36;"
}, {
  currency: "Aruba Guilder",
  currencyCode: "AWG",
  currencySymbol: "&#402;"
}, {
  currency: "Australia Dollar",
  currencyCode: "AUD",
  currencySymbol: "&#36;"
}, {
  currency: "Azerbaijan New Manat",
  currencyCode: "AZN",
  currencySymbol: "&#1084;&#1072;&#1085;"
}, {
  currency: "Bahamas Dollar",
  currencyCode: "BSD",
  currencySymbol: "&#36;"
}, {
  currency: "Barbados Dollar",
  currencyCode: "BBD",
  currencySymbol: "&#36;"
}, {
  currency: "Belarus Ruble",
  currencyCode: "BYR",
  currencySymbol: "&#112;&#46;"
}, {
  currency: "Belize Dollar",
  currencyCode: "BZD",
  currencySymbol: "&#66;&#90;&#36;"
}, {
  currency: "Bermuda Dollar",
  currencyCode: "BMD",
  currencySymbol: "&#36;"
}, {
  currency: "Bolivia Boliviano",
  currencyCode: "BOB",
  currencySymbol: "&#36;&#98;"
}, {
  currency: "Bosnia and Herzegovina Convertible Marka",
  currencyCode: "BAM",
  currencySymbol: "&#75;&#77;"
}, {
  currency: "Botswana Pula",
  currencyCode: "BWP",
  currencySymbol: "&#80;"
}, {
  currency: "Bulgaria Lev",
  currencyCode: "BGN",
  currencySymbol: "&#1083;&#1074;"
}, {
  currency: "Brazil Real",
  currencyCode: "BRL",
  currencySymbol: "&#82;&#36;"
}, {
  currency: "Brunei Darussalam Dollar",
  currencyCode: "BND",
  currencySymbol: "&#36;"
}, {
  currency: "Cambodia Riel",
  currencyCode: "KHR",
  currencySymbol: "&#6107;"
}, {
  currency: "Canada Dollar",
  currencyCode: "CAD",
  currencySymbol: "&#36;"
}, {
  currency: "Cayman Islands Dollar",
  currencyCode: "KYD",
  currencySymbol: "&#36;"
}, {
  currency: "Chile Peso",
  currencyCode: "CLP",
  currencySymbol: "&#36;"
}, {
  currency: "China Yuan Renminbi",
  currencyCode: "CNY",
  currencySymbol: "&#165;"
}, {
  currency: "Colombia Peso",
  currencyCode: "COP",
  currencySymbol: "&#36;"
}, {
  currency: "Costa Rica Colon",
  currencyCode: "CRC",
  currencySymbol: "&#8353;"
}, {
  currency: "Croatia Kuna",
  currencyCode: "HRK",
  currencySymbol: "&#107;&#110;"
}, {
  currency: "Cuba Peso",
  currencyCode: "CUP",
  currencySymbol: "&#8369;"
}, {
  currency: "Czech Republic Koruna",
  currencyCode: "CZK",
  currencySymbol: "&#75;&#269;"
}, {
  currency: "Denmark Krone",
  currencyCode: "DKK",
  currencySymbol: "&#107;&#114;"
}, {
  currency: "Dominican Republic Peso",
  currencyCode: "DOP",
  currencySymbol: "&#82;&#68;&#36;"
}, {
  currency: "East Caribbean Dollar",
  currencyCode: "XCD",
  currencySymbol: "&#36;"
}, {
  currency: "Egypt Pound",
  currencyCode: "EGP",
  currencySymbol: "&#163;"
}, {
  currency: "El Salvador Colon",
  currencyCode: "SVC",
  currencySymbol: "&#36;"
}, {
  currency: "Estonia Kroon",
  currencyCode: "EEK",
  currencySymbol: "&#107;&#114;"
}, {
  currency: "Euro Member Countries",
  currencyCode: "EUR",
  currencySymbol: "&#8364;"
}, {
  currency: "Falkland Islands (Malvinas) Pound",
  currencyCode: "FKP",
  currencySymbol: "&#163;"
}, {
  currency: "Fiji Dollar",
  currencyCode: "FJD",
  currencySymbol: "&#36;"
}, {
  currency: "Ghana Cedis",
  currencyCode: "GHC",
  currencySymbol: "&#162;"
}, {
  currency: "Gibraltar Pound",
  currencyCode: "GIP",
  currencySymbol: "&#163;"
}, {
  currency: "Guatemala Quetzal",
  currencyCode: "GTQ",
  currencySymbol: "&#81;"
}, {
  currency: "Guernsey Pound",
  currencyCode: "GGP",
  currencySymbol: "&#163;"
}, {
  currency: "Guyana Dollar",
  currencyCode: "GYD",
  currencySymbol: "&#36;"
}, {
  currency: "Honduras Lempira",
  currencyCode: "HNL",
  currencySymbol: "&#76;"
}, {
  currency: "Hong Kong Dollar",
  currencyCode: "HKD",
  currencySymbol: "&#36;"
}, {
  currency: "Hungary Forint",
  currencyCode: "HUF",
  currencySymbol: "&#70;&#116;"
}, {
  currency: "Iceland Krona",
  currencyCode: "ISK",
  currencySymbol: "&#107;&#114;"
}, {
  currency: "India Rupee",
  currencyCode: "INR",
  currencySymbol: "&#x20B9;"
}, {
  currency: "Indonesia Rupiah",
  currencyCode: "IDR",
  currencySymbol: "&#82;&#112;"
}, {
  currency: "Iran Rial",
  currencyCode: "IRR",
  currencySymbol: "&#65020;"
}, {
  currency: "Isle of Man Pound",
  currencyCode: "IMP",
  currencySymbol: "&#163;"
}, {
  currency: "Israel Shekel",
  currencyCode: "ILS",
  currencySymbol: "&#8362;"
}, {
  currency: "Jamaica Dollar",
  currencyCode: "JMD",
  currencySymbol: "&#74;&#36;"
}, {
  currency: "Japan Yen",
  currencyCode: "JPY",
  currencySymbol: "&#165;"
}, {
  currency: "Jersey Pound",
  currencyCode: "JEP",
  currencySymbol: "&#163;"
}, {
  currency: "Kazakhstan Tenge",
  currencyCode: "KZT",
  currencySymbol: "&#1083;&#1074;"
}, {
  currency: "Korea (North) Won",
  currencyCode: "KPW",
  currencySymbol: "&#8361;"
}, {
  currency: "Korea (South) Won",
  currencyCode: "KRW",
  currencySymbol: "&#8361;"
}, {
  currency: "Kyrgyzstan Som",
  currencyCode: "KGS",
  currencySymbol: "&#1083;&#1074;"
}, {
  currency: "Laos Kip",
  currencyCode: "LAK",
  currencySymbol: "&#8365;"
}, {
  currency: "Latvia Lat",
  currencyCode: "LVL",
  currencySymbol: "&#76;&#115;"
}, {
  currency: "Lebanon Pound",
  currencyCode: "LBP",
  currencySymbol: "&#163;"
}, {
  currency: "Liberia Dollar",
  currencyCode: "LRD",
  currencySymbol: "&#36;"
}, {
  currency: "Lithuania Litas",
  currencyCode: "LTL",
  currencySymbol: "&#76;&#116;"
}, {
  currency: "Macedonia Denar",
  currencyCode: "MKD",
  currencySymbol: "&#1076;&#1077;&#1085;"
}, {
  currency: "Malaysia Ringgit",
  currencyCode: "MYR",
  currencySymbol: "&#82;&#77;"
}, {
  currency: "Mauritius Rupee",
  currencyCode: "MUR",
  currencySymbol: "&#8360;"
}, {
  currency: "Mexico Peso",
  currencyCode: "MXN",
  currencySymbol: "&#36;"
}, {
  currency: "Mongolia Tughrik",
  currencyCode: "MNT",
  currencySymbol: "&#8366;"
}, {
  currency: "Mozambique Metical",
  currencyCode: "MZN",
  currencySymbol: "&#77;&#84;"
}, {
  currency: "Namibia Dollar",
  currencyCode: "NAD",
  currencySymbol: "&#36;"
}, {
  currency: "Nepal Rupee",
  currencyCode: "NPR",
  currencySymbol: "&#8360;"
}, {
  currency: "Netherlands Antilles Guilder",
  currencyCode: "ANG",
  currencySymbol: "&#402;"
}, {
  currency: "New Zealand Dollar",
  currencyCode: "NZD",
  currencySymbol: "&#36;"
}, {
  currency: "Nicaragua Cordoba",
  currencyCode: "NIO",
  currencySymbol: "&#67;&#36;"
}, {
  currency: "Nigeria Naira",
  currencyCode: "NGN",
  currencySymbol: "&#8358;"
}, {
  currency: "Norway Krone",
  currencyCode: "NOK",
  currencySymbol: "&#107;&#114;"
}, {
  currency: "Oman Rial",
  currencyCode: "OMR",
  currencySymbol: "&#65020;"
}, {
  currency: "Pakistan Rupee",
  currencyCode: "PKR",
  currencySymbol: "&#8360;"
}, {
  currency: "Panama Balboa",
  currencyCode: "PAB",
  currencySymbol: "&#66;&#47;&#46;"
}, {
  currency: "Paraguay Guarani",
  currencyCode: "PYG",
  currencySymbol: "&#71;&#115;"
}, {
  currency: "Peru Nuevo Sol",
  currencyCode: "PEN",
  currencySymbol: "&#83;&#47;&#46;"
}, {
  currency: "Philippines Peso",
  currencyCode: "PHP",
  currencySymbol: "&#8369;"
}, {
  currency: "Poland Zloty",
  currencyCode: "PLN",
  currencySymbol: "&#122;&#322;"
}, {
  currency: "Qatar Riyal",
  currencyCode: "QAR",
  currencySymbol: "&#65020;"
}, {
  currency: "Romania New Leu",
  currencyCode: "RON",
  currencySymbol: "&#108;&#101;&#105;"
}, {
  currency: "Russia Ruble",
  currencyCode: "RUB",
  currencySymbol: "&#1088;&#1091;&#1073;"
}, {
  currency: "Saint Helena Pound",
  currencyCode: "SHP",
  currencySymbol: "&#163;"
}, {
  currency: "Saudi Arabia Riyal",
  currencyCode: "SAR",
  currencySymbol: "&#65020;"
}, {
  currency: "Serbia Dinar",
  currencyCode: "RSD",
  currencySymbol: "&#1044;&#1080;&#1085;&#46;"
}, {
  currency: "Seychelles Rupee",
  currencyCode: "SCR",
  currencySymbol: "&#8360;"
}, {
  currency: "Singapore Dollar",
  currencyCode: "SGD",
  currencySymbol: "&#36;"
}, {
  currency: "Solomon Islands Dollar",
  currencyCode: "SBD",
  currencySymbol: "&#36;"
}, {
  currency: "Somalia Shilling",
  currencyCode: "SOS",
  currencySymbol: "&#83;"
}, {
  currency: "South Africa Rand",
  currencyCode: "ZAR",
  currencySymbol: "&#82;"
}, {
  currency: "Sri Lanka Rupee",
  currencyCode: "LKR",
  currencySymbol: "&#8360;"
}, {
  currency: "Sweden Krona",
  currencyCode: "SEK",
  currencySymbol: "&#107;&#114;"
}, {
  currency: "Switzerland Franc",
  currencyCode: "CHF",
  currencySymbol: "&#67;&#72;&#70;"
}, {
  currency: "Suriname Dollar",
  currencyCode: "SRD",
  currencySymbol: "&#36;"
}, {
  currency: "Syria Pound",
  currencyCode: "SYP",
  currencySymbol: "&#163;"
}, {
  currency: "Taiwan New Dollar",
  currencyCode: "TWD",
  currencySymbol: "&#78;&#84;&#36;"
}, {
  currency: "Thailand Baht",
  currencyCode: "THB",
  currencySymbol: "&#3647;"
}, {
  currency: "Trinidad and Tobago Dollar",
  currencyCode: "TTD",
  currencySymbol: "&#84;&#84;&#36;"
}, {
  currency: "Turkey Lira",
  currencyCode: "TRY",
  currencySymbol: "&#x20BA;"
}, {
  currency: "Turkey Lira",
  currencyCode: "TRL",
  currencySymbol: "&#8356;"
}, {
  currency: "Tuvalu Dollar",
  currencyCode: "TVD",
  currencySymbol: "&#36;"
}, {
  currency: "Ukraine Hryvna",
  currencyCode: "UAH",
  currencySymbol: "&#8372;"
}, {
  currency: "United Kingdom Pound",
  currencyCode: "GBP",
  currencySymbol: "&#163;"
}, {
  currency: "United States Dollar",
  currencyCode: "USD",
  currencySymbol: "&#36;"
}, {
  currency: "Uruguay Peso",
  currencyCode: "UYU",
  currencySymbol: "&#36;&#85;"
}, {
  currency: "Uzbekistan Som",
  currencyCode: "UZS",
  currencySymbol: "&#1083;&#1074;"
}, {
  currency: "Venezuela Bolivar",
  currencyCode: "VEF",
  currencySymbol: "&#66;&#115;"
}, {
  currency: "Viet Nam Dong",
  currencyCode: "VND",
  currencySymbol: "&#8363;"
}, {
  currency: "Yemen Rial",
  currencyCode: "YER",
  currencySymbol: "&#65020;"
}, {
  currency: "Zimbabwe Dollar",
  currencyCode: "ZWD",
  currencySymbol: "&#90;&#36;"
}], Cr = ["currencyCode", "isRequired", "size", "value", "isDisabled", "placeholder", "onChange", "onBlur", "locale", "labelProp", "infoProp", "trailingText", "inputState", "helperTextProp", "inputAlignment"], Sr = /* @__PURE__ */ O.div.withConfig({
  displayName: "currencyInput__StyledCurrencyInput",
  componentId: "sc-85t4i6-0"
})(["&.CurrencyInput{", ";}"], function(i) {
  var r = i.theme.components.currencyInput;
  return z(r.CurrencyInput);
}), br = /* @__PURE__ */ O.div.withConfig({
  displayName: "currencyInput__StartAdornmentContainer",
  componentId: "sc-85t4i6-1"
})(["&.AdornmentContainer{", ";}"], function(i) {
  var r = i.theme.components.currencyInput;
  return z(r.AdornmentContainer);
}), fc = function(r) {
  var c = r.currencyCode, o = c === void 0 ? "USD" : c, m = r.isRequired, g = m === void 0 ? !1 : m, t = r.size, d = t === void 0 ? "medium" : t, D = r.value, y = D === void 0 ? "" : D, S = r.isDisabled, p = S === void 0 ? !1 : S, R = r.placeholder, B = R === void 0 ? "00.00" : R, h = r.onChange, P = r.onBlur, b = r.locale, s = b === void 0 ? "en-us" : b, f = r.labelProp, N = r.infoProp, L = r.trailingText, v = r.inputState, K = r.helperTextProp, A = r.inputAlignment, $ = A === void 0 ? "right" : A, V = cr(r, Cr), Y = yr({
    label: "CurrencyInput"
  }), k = v || ar.NONE, Z = !0, T = nr(null), E = or(null), M = E[0], I = E[1];
  ur(function() {
    var l = T.current;
    l && (l == null || l.setSelectionRange(M, M));
  }, [T, M, y]);
  var W = function(e) {
    var C = e.value, a = e.diff, u = e.total;
    C.length === 0 ? I(1) : a === 0 ? I(u) : a < 0 ? I(u + Math.abs(a) - 1) : I(u - Math.abs(a) + 1);
  }, F = function(e, C, a) {
    a === void 0 && (a = !1);
    var u = tr({
      value: C
    });
    u = u.replace(",", ".");
    var Q = lr(".", u), w = parseFloat(u), n = "";
    if (u.charAt(u.length - 1) !== ".") {
      var x = 2;
      a || (x = Math.min(Q, 2));
      var _ = new Intl.NumberFormat(s, {
        style: "currency",
        currency: o,
        minimumFractionDigits: x,
        maximumFractionDigits: x,
        currencyDisplay: "narrowSymbol"
      }).format(w);
      isNaN(w) || (n = _);
    } else {
      var X = new Intl.NumberFormat(s, {
        style: "currency",
        currency: o,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        currencyDisplay: "narrowSymbol"
      }).format(w);
      n = X + ".";
    }
    n = n.includes("-") && n.charAt(0) === "-" ? "-" + n.slice(2) : n.slice(1), n.includes(" ") && (n = n.split(" ")[1]), u === "-" && (n = "-" + n);
    var rr = e.target.selectionEnd, er = (y == null ? void 0 : y.length) - n.length;
    W({
      value: y,
      diff: er,
      total: rr
    }), e.target.value = n, h && h(e);
  }, j = function(e) {
    F(e, e.target.value);
  }, q = function(e) {
    F(e, e.target.value, Z), P && P(e);
  }, J = function(e) {
    var C = pr.find(function(a) {
      var u = a.currencyCode;
      return u === e;
    });
    return /* @__PURE__ */ G(br, {
      id: "AdornmentContainer",
      className: H(["AdornmentContainer", "AdornmentContainer--" + d, {
        "AdornmentContainer--disabled": p,
        "AdornmentContainer--typed": (y == null ? void 0 : y.length) > 0
      }]),
      dangerouslySetInnerHTML: {
        __html: C ? C.currencySymbol : ""
      }
    });
  };
  return /* @__PURE__ */ G(Sr, Object.assign({
    className: H(["CurrencyInput", "CurrencyInput--" + $, "CurrencyInput--" + d, {
      "CurrencyInput--disabled": p,
      "CurrencyInput--typed": (y == null ? void 0 : y.length) > 0
    }])
  }, Y, {
    children: /* @__PURE__ */ G(ir, Object.assign({
      role: "textbox",
      inputRef: T,
      value: y,
      placeholder: B,
      inputState: k,
      textSize: d,
      required: g,
      helperTextProp: K,
      disabled: p,
      startAdornmentProp: {
        startAdornment: J(o)
      },
      onChange: j,
      onBlur: q,
      maxLength: 15,
      labelProp: f,
      infoProp: N,
      trailingText: L
    }, V))
  }));
};
export {
  fc as CurrencyInput
};
